import { NumberField as EFCNumberField } from 'enova-frontend-components';
import { FC } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  error?: FieldError;
  value?: number;
  onChange: (value: number | null) => void;
  labelKey?: string;
  informationKey?: string;
  disabled?: boolean;
  required?: boolean;
}

export const YearNumberField: FC<Props> = ({
  error,
  value,
  onChange,
  labelKey,
  informationKey,
  disabled,
  required
}) => {
  const { t } = useTranslation();
  const defaultKey = 'register.tekniskUtstyr.installasjonsAr';

  return (
    <EFCNumberField
      required={!!required}
      format="####"
      disabled={!!disabled}
      error={!!error}
      helperText={error && error.message}
      value={value}
      integer
      onValueChange={({ floatValue }) => {
        onChange(floatValue || null);
      }}
      label={t(labelKey || `${defaultKey}.label`)}
      aria-label={t(labelKey || `${defaultKey}.label`)}
      HelperBoxProps={{
        'aria-label': t('readFieldInformation'),
        children: t(informationKey || `${defaultKey}.information`)
      }}
    />
  );
};
